export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const PlaytechGamesData = {
  PlaytechGamesData: {
    slide1: {
      FlipRoyale: {
        href: "/casino/aggapplaytech-flip-royale",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_flip_royale.webp",
        alt: "Flip Royale",
        name: "Flip Royale",
      },
      TenTonWaysStampede: {
        href: "/casino/aggapplaytech-ten-ton-ways-stampede",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_ten_ton_ways_stampede.webp",
        alt: "Ten Ton Ways Stampede",
        name: "Ten Ton Ways Stampede",
      },
      CashTruckBegins: {
        href: "/casino/aggapplaytech-cash-truck-begins",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_cash_truck_begins.webp",
        alt: "Cash Truck Begins",
        name: "Cash Truck Begins",
      },
      GigaMatchEgypt: {
        href: "/casino/aggapplaytech-giga-match-egypt",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_giga_match_egypt.webp",
        alt: "Giga Match Egypt",
        name: "Giga Match Egypt",
      },
      ImmortalWaysVolcano: {
        href: "/casino/aggapplaytech-immortal-ways-volcano",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_immortal_ways_volcano.webp",
        alt: "Immortal Ways Volcano",
        name: "Immortal Ways Volcano",
      },
      JokerSpinRoll: {
        href: "/casino/aggapplaytech-joker-spin-and-roll",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_joker_spin__roll.webp",
        alt: "Joker Spin & Roll",
        name: "Joker Spin & Roll",
      },
      FullMoonWhitePandaPowerPlayJackpot: {
        href: "/casino/aggapplaytech-full-moon-white-panda-powerplay-jackpot",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl:
          "./images/playtech/plt_full_moon_white_panda_powerplay_jackpot.webp",
        alt: "Full Moon: White Panda PowerPlay Jackpot",
        name: "Full Moon: White Panda PowerPlay Jackpot",
      },
      GoldTrioLilDemon: {
        href: "/casino/aggapplaytech-gold-trio-lil-demon",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_gold_trio_lil_demon.webp",
        alt: "Gold Trio: Lil Demon",
        name: "Gold Trio: Lil Demon",
      },
      ShieldsofLambda: {
        href: "/casino/aggapplaytech-shields-of-lambda",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_shields_of_lambda.webp",
        alt: "Shields of Lambda",
        name: "Shields of Lambda",
      },
      MegaFireBlaze3Wizards: {
        href: "/casino/aggapplaytech-mega-fire-blaze-3-wizards",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_mega_fire_blaze_3_wizards.webp",
        alt: "Mega Fire Blaze: 3 Wizards",
        name: "Mega Fire Blaze: 3 Wizards",
      },
      MiniRoulette: {
        href: "/casino/aggapplaytech-mini-roulette",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_mini_roulette.webp",
        alt: "Mini Roulette",
        name: "Mini Roulette",
      },
      SpinaWin: {
        href: "/casino/aggapplaytech-spin-a-win",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_spin_a_win.webp",
        alt: "Spin a Win",
        name: "Spin a Win",
      },
      yollarinkrali: {
        href: "/casino/aggapplaytech-roulette-mini",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_roulette_mini.webp",
        alt: "Roulette Mini",
        name: "Roulette Mini",
      },
      AztecaBonusLinesPowerPlayJackpot: {
        href: "/casino/aggapplaytech-azteca-bonus-lines-powerplay-jackpot",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl:
          "./images/playtech/plt_azteca_bonus_lines_powerplay_jackpot.webp",
        alt: "Azteca: Bonus Lines PowerPlay Jackpot",
        name: "Azteca: Bonus Lines PowerPlay Jackpot",
      },
      LunarLinkPhoenixMoons: {
        href: "/casino/aggapplaytech-lunar-link-phoenix-moons",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_lunar_link_phoenix_moons.webp",
        alt: "Lunar Link: Phoenix Moons",
        name: "Lunar Link: Phoenix Moons",
      },
      AztecFruits: {
        href: "/casino/aggapplaytech-aztec-fruits",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_aztec_fruits.webp",
        alt: "Aztec Fruits",
        name: "Aztec Fruits",
      },
      GoldTrioLeprechaunsLuckBF: {
        href: "/casino/aggapplaytech-gold-trio-leprechauns-luck-bf",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_gold_trio_leprechauns_luck_bf.webp",
        alt: "Gold Trio: Leprechaun's Luck BF",
        name: "Gold Trio: Leprechaun's Luck BF",
      },
      ElRancheroCashCollectDiamondPath: {
        href: "/casino/aggapplaytech-el-ranchero-cash-collect-diamond-path",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl:
          "./images/playtech/plt_el_ranchero_cash_collect_diamond_path.webp",
        alt: "El Ranchero Cash Collect: Diamond Path",
        name: "El Ranchero Cash Collect: Diamond Path",
      },
      DropforTop: {
        href: "/casino/aggapplaytech-drop-for-top",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_drop_for_top.webp",
        alt: "Drop for Top",
        name: "Drop for Top",
      },
      ReactionLink: {
        href: "/casino/aggapplaytech-reaction-link",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_reaction_link.webp",
        alt: "Reaction Link",
        name: "Reaction Link",
      },
      WildRoll: {
        href: "/casino/aggapplaytech-wild-roll",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_wild_roll.webp",
        alt: "Wild Roll",
        name: "Wild Roll",
      },
      PiggiesandtheBankCashCollectLink: {
        href: "/casino/aggapplaytech-piggies-and-the-bank-cash-collect-and-link",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl:
          "./images/playtech/plt_piggies_and_the_bank_cash_collect__link.webp",
        alt: "Piggies and the Bank: Cash Collect & Link",
        name: "Piggies and the Bank: Cash Collect & Link",
      },
      GooodHeavens: {
        href: "/casino/aggapplaytech-goood-heavens",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_goood_heavens.webp",
        alt: "Goood Heavens",
        name: "Goood Heavens",
      },
      StreakofLuckDoubleDice: {
        href: "/casino/aggapplaytech-streak-of-luck-double-dice",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_streak_of_luck_double_dice.webp",
        alt: "Streak of Luck: Double Dice",
        name: "Streak of Luck: Double Dice",
      },
      PiggiesandtheBankLuckyTap: {
        href: "/casino/aggapplaytech-piggies-and-the-bank-lucky-tap",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_piggies_and_the_bank_lucky_tap.webp",
        alt: "Piggies and the Bank: Lucky Tap",
        name: "Piggies and the Bank: Lucky Tap",
      },
      FluffyFavouritesCashCollect: {
        href: "/casino/aggapplaytech-fluffy-favourites-cash-collect",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_fluffy_favourites_cash_collect.webp",
        alt: "Fluffy Favourites: Cash Collect",
        name: "Fluffy Favourites: Cash Collect",
      },
      TreeWishes: {
        href: "/casino/aggapplaytech-tree-wishes",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_tree_wishes.webp",
        alt: "Tree Wishes",
        name: "Tree Wishes",
      },
      LilSphinx: {
        href: "/casino/aggapplaytech-lil-sphinx",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_lil_sphinx.webp",
        alt: "Lil Sphinx",
        name: "Lil Sphinx",
      },
      LunarLinkTheLegendofKingArthur: {
        href: "/casino/aggapplaytech-lunar-link-the-legend-of-king-arthur",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl:
          "./images/playtech/plt_lunar_link_the_legend_of_king_arthur.webp",
        alt: "Lunar Link: The Legend of King Arthur",
        name: "Lunar Link: The Legend of King Arthur",
      },
      LightsofLuck: {
        href: "/casino/aggapplaytech-lights-of-luck",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_lights_of_luck.webp",
        alt: "Lights of Luck",
        name: "Lights of Luck",
      },
      DevilWilds: {
        href: "/casino/aggapplaytech-devil-wilds",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_devil_wilds.webp",
        alt: "Devil Wilds",
        name: "Devil Wilds",
      },
      PyramidLinx: {
        href: "/casino/aggapplaytech-pyramid-linx",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_pyramid_linx.webp",
        alt: "Pyramid Linx",
        name: "Pyramid Linx",
      },
      TigerTurtleDragonPhoenix: {
        href: "/casino/aggapplaytech-tiger-turtle-dragon-phoenix",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_tiger_turtle_dragon_phoenix.webp",
        alt: "Tiger Turtle Dragon Phoenix",
        name: "Tiger Turtle Dragon Phoenix",
      },
      HoneyGems: {
        href: "/casino/aggapplaytech-honey-gems",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_honey_gems.webp",
        alt: "Honey Gems",
        name: "Honey Gems",
      },
      TheGreatGenie: {
        href: "/casino/aggapplaytech-the-great-genie",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_the_great_genie.webp",
        alt: "The Great Genie",
        name: "The Great Genie",
      },
      PremiumFrenchRoulette: {
        href: "/casino/aggapplaytech-premium-french-roulette",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_premium_french_roulette.webp",
        alt: "Premium French Roulette",
        name: "Premium French Roulette",
      },
      LuckyGiftCashCollect: {
        href: "/casino/aggapplaytech-lucky-gift-cash-collect",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_lucky_gift_cash_collect.webp",
        alt: "Lucky Gift: Cash Collect",
        name: "Lucky Gift: Cash Collect",
      },
      ExtremeFruitsUltimateDeluxe: {
        href: "/casino/aggapplaytech-extreme-fruits-ultimate-deluxe",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_extreme_fruits_ultimate.webp",
        alt: "Extreme Fruits Ultimate Deluxe",
        name: "Extreme Fruits Ultimate Deluxe",
      },
      AgeoftheGodsCashCollect: {
        href: "/casino/aggapplaytech-age-of-the-gods-cash-collect",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_age_of_the_gods_cash_collect.webp",
        alt: "Age of the Gods: Cash Collect",
        name: "Age of the Gods: Cash Collect",
      },
      BullsEyeAlice: {
        href: "/casino/aggapplaytech-bulls-eye-alice",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_bulls_eye_alice.webp",
        alt: "Bulls Eye Alice",
        name: "Bulls Eye Alice",
      },
      SweetnJuicy: {
        href: "/casino/aggapplaytech-sweet-n-juicy",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_sweet_n_juicy.webp",
        alt: "Sweet n' Juicy",
        name: "Sweet n' Juicy",
      },
      QueensMystery: {
        href: "/casino/aggapplaytech-queens-mystery",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_queens_mystery.webp",
        alt: "Queen's Mystery",
        name: "Queen's Mystery",
      },
      FullMoonWhiteKing: {
        href: "/casino/aggapplaytech-full-moon-white-king",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_full_moon_white_king.webp",
        alt: "Full Moon: White King",
        name: "Full Moon: White King",
      },
      LuckyBassMegaCashCollect: {
        href: "/casino/aggapplaytech-lucky-bass-mega-cash-collect",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_lucky_bass_mega_cash_collect.webp",
        alt: "Lucky Bass: Mega Cash Collect",
        name: "Lucky Bass: Mega Cash Collect",
      },
      GoldHitLinkTigeJones: {
        href: "/casino/aggapplaytech-gold-hit-and-link-tiger-jones",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_gold_hit__link_tiger_jones.webp",
        alt: "Gold Hit & Link: Tiger Jones",
        name: "Gold Hit & Link: Tiger Jones",
      },
      MacabraLinxPowerplayJackpot: {
        href: "/casino/aggapplaytech-macabra-linx-powerplay-jackpot",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_macabra_linx_powerplay_jackpot.webp",
        alt: "Macabra Linx: Powerplay Jackpot",
        name: "Macabra Linx: Powerplay Jackpot",
      },
      DiamondMatchDeluxe: {
        href: "/casino/aggapplaytech-diamond-match-deluxe",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_diamond_match_deluxe.webp",
        alt: "Diamond Match Deluxe",
        name: "Diamond Match Deluxe",
      },
      QuadLinkRed: {
        href: "/casino/aggapplaytech-quad-link-red",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_quad_link_red.webp",
        alt: "Quad Link Red",
        name: "Quad Link Red",
      },
      RomanFruits: {
        href: "/casino/aggapplaytech-roman-fruits",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_roman_fruits.webp",
        alt: "Roman Fruits",
        name: "Roman Fruits",
      },
      LilDemonMegaCashCollect: {
        href: "/casino/aggapplaytech-lil-demon-mega-cash-collect",
        code: "",
        casino: "Slots",
        provider: "Playtech Games",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/playtech/plt_lil_demon_mega_cash_collect.webp",
        alt: "Lil Demon: Mega Cash Collect",
        name: "Lil Demon: Mega Cash Collect",
      },
    },
    name: "Playtech Games",
    key: "playtechgames",
  },
};
